import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { LoginService } from '@shared-angular/services/login.service';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const loggedInUserResolver: ResolveFn<Promise<boolean>> = async (route, state) => {
  const loginService: LoginService = inject(LoginService);
  // persist=false: Token wird erst nach Bestaetigung des Datenschutzhinweises in BotBasedComponent persistiert
  const login = await loginService.loadMyUser(false);
  return login != null;
};
